import { ALLOWED_SECTIONS, isAllowedSection } from '../../config/sections'
import {
  isRegisteredAdminExtensionSectionKey,
  resolveAdminExtensionRouteByPath,
} from '../../components/admin-shell/admin-extension-registry'
import {
  resolveTeamEditUserIdFromPath,
  resolveSectionFromDashboardPath,
  resolveShopProductIdFromPath,
} from './section-routing/pathRoutes'

export { ALLOWED_SECTIONS } from '../../config/sections'

const resolveSectionAlias = (value: string | null): string | null => {
  if (!value) return null
  const normalized = value.trim()
  if (!normalized) return null
  return isAllowedSection(normalized) ? normalized : null
}

const resolveExtensionSectionAlias = (value: string | null): string | null => {
  if (!value) return null
  const normalized = value.trim()
  if (!normalized) return null
  return isRegisteredAdminExtensionSectionKey(normalized) ? normalized : null
}

export const resolveSectionFromLocation = (
  search: string,
  _hash: string,
  pathname = '',
): string | null => {
  const extensionRoute = resolveAdminExtensionRouteByPath(pathname)
  if (extensionRoute) return extensionRoute.key

  const dashboardPathSection = resolveSectionFromDashboardPath(pathname)
  if (dashboardPathSection) return dashboardPathSection

  const params = new URLSearchParams(search)
  const sectionFromQuery = resolveSectionAlias(params.get('section'))
  if (sectionFromQuery) {
    return sectionFromQuery
  }
  const extensionSectionFromQuery = resolveExtensionSectionAlias(params.get('section'))
  if (extensionSectionFromQuery) {
    return extensionSectionFromQuery
  }

  return null
}

export type AdminNavigationState = {
  section: string | null
  selectedUserId: string | null
  selectedShopProductId: string | null
  selectedSupportRequestId: string | null
  pageMode: 'edit' | 'create' | null
  pageId: string | undefined
  cleanQueryForHashRoutes: boolean
}

export const parseAdminNavigationState = (
  search: string,
  _hash: string,
  pathname: string,
): AdminNavigationState => {
  const params = new URLSearchParams(search)
  const dashboardPathSection = resolveSectionFromDashboardPath(pathname)
  const sectionFromQuery = resolveSectionAlias(params.get('section'))

  const resolvedSection = dashboardPathSection ?? sectionFromQuery ?? null
  const extensionSectionFromQuery = resolveExtensionSectionAlias(params.get('section'))
  const finalResolvedSection = resolvedSection ?? extensionSectionFromQuery
  const pageModeParam = params.get('pageMode')
  const pageMode =
    pageModeParam === 'edit' || pageModeParam === 'create'
      ? pageModeParam
      : null
  const pageId = params.get('pageId') || undefined
  const selectedShopProductIdFromPath = resolveShopProductIdFromPath(pathname)
  const selectedShopProductIdFromQuery = params.get('productId')
  const selectedShopProductId =
    finalResolvedSection === 'shop-products'
      ? selectedShopProductIdFromPath ?? selectedShopProductIdFromQuery
      : null
  const selectedUserIdFromPath = resolveTeamEditUserIdFromPath(pathname)
  const selectedUserIdFromQuery = params.get('userId')

  return {
    section: finalResolvedSection,
    selectedUserId:
      finalResolvedSection === 'profile-team-edit'
        ? selectedUserIdFromPath ?? selectedUserIdFromQuery
        : null,
    selectedShopProductId,
    selectedSupportRequestId:
      finalResolvedSection === 'support-inbox'
        ? params.get('supportRequestId')?.trim() || null
        : null,
    pageMode,
    pageId,
    cleanQueryForHashRoutes: false,
  }
}
